var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHireTalentLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "413.000000pt",
    height: "76.000000pt",
    viewBox: "0,0,256,47.09375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.10847,0.88743) scale(0.61985,0.61985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,76) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,380c0,-212 1,-298 2,-193c2,106 2,280 0,385c-1,106 -2,20 -2,-192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4125,380c0,-212 1,-298 2,-193c2,106 2,280 0,385c-1,106 -2,20 -2,-192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3958,659c-44,-25 -3,-93 42,-69c26,14 26,56 1,70c-23,12 -22,12 -43,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,625c-57,-18 -124,-74 -153,-129c-31,-58 -31,-174 0,-232c42,-79 147,-144 233,-144c45,0 127,29 160,56c29,25 30,29 30,107v81l-48,-47c-26,-26 -53,-47 -59,-47c-6,0 -29,20 -51,46l-40,45l-7,-90c-8,-101 -14,-107 -72,-71l-33,20v164c0,222 8,228 124,101c37,-41 72,-75 78,-75c6,0 40,26 76,57l64,57l-44,42c-71,67 -164,88 -258,59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429,581c-38,-38 -39,-87 -4,-129c32,-38 65,-46 109,-28c101,42 71,186 -39,186c-27,0 -44,-8 -66,-29zM1518,528c8,-7 12,-7 12,1c0,14 47,15 55,0c12,-19 -29,-45 -73,-47c-36,-2 -44,2 -52,21l-9,22v-22c-1,-25 -31,-33 -31,-9c0,8 -3,21 -6,30c-5,13 3,15 43,15c26,-1 54,-6 61,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640,560c0,-14 5,-18 17,-13c14,6 15,0 9,-45l-7,-52h36h36l-7,52c-6,45 -5,51 9,45c12,-5 17,-1 17,13c0,18 -7,20 -55,20c-48,0 -55,-2 -55,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817,525c-9,-31 -17,-60 -17,-65c0,-13 37,-13 45,0c3,6 15,10 26,10c10,0 19,-4 19,-10c0,-5 11,-10 25,-10c18,0 25,5 25,18c0,10 -3,22 -7,26c-5,4 -13,24 -18,44c-9,33 -15,37 -46,40c-34,3 -35,2 -52,-53zM1880,520c0,-11 -4,-20 -10,-20c-5,0 -10,9 -10,20c0,11 5,20 10,20c6,0 10,-9 10,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2004,515v-65h48c42,0 48,3 48,21c0,16 -4,19 -22,14c-20,-7 -21,-5 -15,44l6,51h-33h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155,515v-65h53c45,0 52,3 52,20c0,17 -5,19 -25,14c-19,-5 -25,-2 -25,10c0,9 7,16 15,16c8,0 15,5 15,10c0,6 -5,9 -11,8c-6,-2 -14,3 -17,11c-3,10 2,13 22,9c20,-4 26,-1 26,13c0,16 -8,19 -52,19h-53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2324,515c0,-62 0,-65 24,-65c22,0 24,3 18,33l-6,32l20,-25c11,-14 20,-28 20,-32c0,-5 15,-8 33,-8h32v65c0,61 -1,65 -23,65c-21,0 -23,-3 -16,-32c6,-29 5,-31 -9,-19c-9,7 -19,21 -22,32c-5,13 -16,19 -38,19h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530,560c0,-14 5,-18 17,-13c14,6 15,0 9,-45l-7,-52h35h35l-6,52c-5,45 -4,51 10,45c12,-5 17,-1 17,13c0,18 -7,20 -55,20c-48,0 -55,-2 -55,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939,566c-2,-2 -3,-81 -1,-175l3,-171h34h35v125c0,69 4,125 8,125c5,0 21,-56 37,-125l28,-125h37h37l28,118c15,64 31,124 36,132c5,9 9,-39 9,-117v-133h40h40v175v176l-67,-3l-67,-3l-26,-105c-14,-57 -29,-100 -32,-95c-3,6 -16,54 -29,108l-23,97h-61c-34,0 -64,-2 -66,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680,395v-175h50h50v64v63l61,6c47,4 68,11 86,29c29,30 40,87 23,128c-20,48 -55,60 -170,60h-100zM2855,460c0,-33 -2,-35 -37,-38l-38,-3v41v41l38,-3c35,-3 37,-5 37,-38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3350,395v-175h40h40v175v175h-40h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682,523c5,-26 38,-29 38,-4c0,15 -6,21 -21,21c-14,0 -19,-5 -17,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3952,528c-8,-8 -12,-56 -12,-149c0,-112 3,-141 16,-153c20,-21 37,-20 57,2c14,15 17,41 17,146c0,70 -5,136 -10,147c-12,21 -50,25 -68,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,469c-9,-16 -9,-28 -1,-46c9,-20 17,-24 44,-21c30,3 32,5 32,43c0,38 -2,40 -32,43c-24,2 -34,-2 -43,-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3084,470c-11,-4 -33,-22 -47,-40c-52,-61 -30,-172 39,-205c41,-19 64,-19 94,2c17,12 25,13 28,5c2,-7 21,-12 43,-12h39v125v125h-39c-22,0 -41,-5 -43,-11c-2,-6 -14,-5 -33,5c-33,18 -50,19 -81,6zM3188,388c7,-7 12,-27 12,-45c0,-24 -7,-37 -26,-50c-24,-15 -29,-15 -53,-2c-29,16 -39,56 -21,89c12,23 68,28 88,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3683,473c-12,-2 -36,-20 -53,-39c-25,-29 -30,-43 -30,-85c0,-64 20,-102 64,-123c43,-20 65,-20 96,1c17,12 25,13 28,5c2,-7 21,-12 43,-12h39v125v125h-39c-22,0 -41,-5 -43,-11c-2,-6 -14,-5 -33,5c-31,16 -33,16 -72,9zM3780,380c18,-33 8,-73 -21,-89c-24,-13 -29,-13 -53,2c-28,19 -34,53 -16,88c15,27 75,26 90,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828,423c184,-3 192,-4 192,-23c0,-11 -7,-20 -15,-20c-8,0 -15,-7 -15,-15c0,-8 7,-15 15,-15c12,0 15,-13 15,-60c0,-66 12,-80 69,-80c35,0 43,24 11,33c-17,4 -20,14 -20,56c0,44 3,51 20,51c11,0 20,7 20,15c0,8 -9,15 -20,15c-13,0 -20,7 -20,20c0,19 8,20 283,23c155,1 55,2 -223,2c-278,0 -418,-1 -312,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717,384c-4,-4 -7,-20 -7,-36c0,-25 3,-28 36,-28c34,0 35,1 32,33c-2,26 -8,33 -28,35c-14,2 -29,0 -33,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430,362c-62,-31 -71,-98 -18,-131c37,-23 132,-26 185,-5l48,18l-40,7c-22,4 -49,2 -61,-3c-28,-13 -70,-3 -78,17c-4,13 9,15 89,15c84,0 95,2 95,18c0,68 -134,108 -220,64zM1546,336c10,-8 16,-17 12,-21c-9,-9 -60,-15 -81,-8c-18,5 -18,6 -1,24c20,23 43,24 70,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700,293v-84l43,3l42,3l5,55c5,53 6,55 35,55c29,0 30,-2 35,-55l5,-55l43,-3l42,-3v64c0,36 -6,71 -13,81c-18,25 -87,32 -124,12c-26,-13 -32,-13 -36,-2c-3,8 -20,14 -41,14h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224,369c-44,-13 -66,-41 -62,-80c4,-43 41,-69 109,-75c102,-10 172,35 155,100c-13,51 -117,80 -202,55zM2328,328c7,-7 12,-21 12,-33c0,-29 -19,-45 -52,-45c-25,0 -48,23 -48,49c0,33 63,54 88,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487,373c-4,-3 -7,-42 -7,-85v-78h45h45v49c0,39 4,53 21,65c12,8 27,12 34,9c14,-5 38,30 28,41c-11,11 -48,6 -71,-10c-20,-14 -22,-14 -22,0c0,11 -10,16 -33,16c-19,0 -37,-3 -40,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,296c-3,-8 -4,-29 -2,-48c3,-32 5,-33 49,-36c46,-3 47,-2 52,30c7,50 -7,68 -54,68c-25,0 -42,-5 -45,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3498,289c-24,-13 -23,-56 1,-69c42,-22 77,25 45,61c-20,22 -22,22 -46,8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireTalentLogo2);
export default __webpack_public_path__ + "static/media/hireTalentLogo2.5e0352c23be8acc61410c3994237c10e.svg";
export { ForwardRef as ReactComponent };